import { render, staticRenderFns } from "./Coins.vue?vue&type=template&id=74c0d6fd&"
import script from "./Coins.vue?vue&type=script&lang=ts&"
export * from "./Coins.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports